import { BaseModel } from './BaseModel';
import CartItem from './CartItem';
import Order from './Order';
import User from './User';

export class Cart extends BaseModel {
  static get entity() {
    return 'carts';
  }

  static get fk() {
    return 'cart_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      user_id: this.attr(null),
      user: this.belongsTo(User, 'user_id'),
      count_items: this.attr(null),
      cart_items_ids: this.attr([]),
      cart_items: this.hasManyBy(CartItem, 'cart_items_ids', 'cart_id'),
      updated_at: this.attr(null),
      delete_at: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      async fetch(params = {}) {
        return this.get(`/carts`, { params });
      },

      async fetchMyCountItems(params = {}, save = true) {
        return this.get(`/carts/count-cart-items`, { params, save });
      },

      async addItem(body = {}) {
        return this.post(`/carts/add-learning-unit-entry`, body);
      },

      async addQuotaItem(body = {}) {
        return this.post(`/carts/add-learning-unit-quota`, body);
      },
      async checkout(body = {}) {
        const { response } = await this.post(`/carts/checkout`, body, { save: false });

        const { data } = response;

        const op = await Order.create({ data });

        return op.orders[0];
      }
    }
  };
}

export default Cart;
